import React, { useEffect } from 'react';

const TestInsuranceRedirect = () => {
  useEffect(() => {
    // Redirect to static HTML file
    window.location.replace('/test-insurance-claims.html');
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#667eea',
      color: 'white',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Redirecting to InsureTrax Testing...</h2>
        <p>If not redirected, <a href="/test-insurance-claims.html" style={{ color: 'white', textDecoration: 'underline' }}>click here</a></p>
      </div>
    </div>
  );
};

export default TestInsuranceRedirect;
